<style>

</style>

<template>
    <div id="services" class="page">
        <fullscreen-loader v-show="servicesLoadStatus == 1"></fullscreen-loader>

        <service-map v-show="servicesView == 'map' "></service-map>
        <service-list v-show="servicesView == 'list' "></service-list>

        <!--<contact-button></contact-button>-->
        <toggle-services-view></toggle-services-view>
        <map-legend></map-legend>

        <router-view></router-view>
    </div>
</template>

<script>
    import ServiceMap from '../components/services/ServiceMap.vue';
    import ServiceList from '../components/services/ServiceList.vue';
    import ToggleServicesView from '../components/services/ToggleServicesView.vue';
    import MapLegend from '../components/services/MapLegend.vue';
    import ContactButton from "../components/services/ContactButton";
    import FullscreenLoader from "../components/global/FullscreenLoader";

    export default {
        components: {
            FullscreenLoader,
            ServiceMap,
            ServiceList,
            ContactButton,
            ToggleServicesView,
            MapLegend
        },

        computed: {
            servicesView() {
                return this.$store.getters.getServicesView;
            },

            servicesLoadStatus() {
                return this.$store.getters.getServicesLoadStatus;
            },
        },
    }
</script>
